<template>
  <div class="content">
    <base-header :choose-index="-1"></base-header>
    <div class="middle_content">
      <img class="middle_content-post" ref="post" src="@@/assets/img/westa/join/bg.png" />
      <div class="middle_content-ditu">
        <div id="amap-wrap" class="middle_content-ditu-left" style="width:600px; height:500px"></div>
        <div class="middle_content-ditu-right">
          <div
            class="middle_content-ditu-right-item"
            v-for="(item, index) in content_contactus"
            :key="index"
            @click="setMap(item.longitude, item.latitude)"
          >
            <div class="middle_content-ditu-right-item-title">{{item.name}}</div>
            <div class="middle_content-ditu-right-item-flex">
              <div
                class="middle_content-ditu-right-item-flex-icon"
                v-bgImg="require('@@/assets/img/westa/join/icon_phone.png')"
              ></div>
              <div>{{item.phone}}</div>
            </div>
            <div class="middle_content-ditu-right-item-flex">
              <div
                class="middle_content-ditu-right-item-flex-icon"
                v-bgImg="require('@@/assets/img/westa/join/icon_address.png')"
              ></div>
              <div>{{item.address}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <base-footer></base-footer>
  </div>
</template>

<script>
import BaseHeader from "@@/components/westa/base-header";
import BaseFooter from "@@/components/westa/base-footer";
export default {
  data() {
    return {
      content_contactus: []
    };
  },
  components: {
    BaseHeader,
    BaseFooter
  },
  created() {
    this.getInfo();
  },
  mounted() {
    this.zoom = 15;
    this.center = [113.188927, 22.776887];
    // this.center = [
    //   this.content_contactus[0].longitude,
    //   this.content_contactus[0].latitude
    // ];
    this.map_ = new AMap.Map("amap-wrap", {
      //初始化地图
      zoom: this.zoom,
      center: this.center
    });

    this.setMarker("marker1", this.center); //点标记1
  },
  methods: {
    getInfo() {
      let params = {};
      this.req
        .get(
          url_api_web_websiteContent_getWebsiteContent,
          this.qs.stringify(params)
        )
        .then(result => {
          this.content_contactus = JSON.parse(
            result.website_content.content_contactus
          );
          console.log(this.content_contactus);
        })
        .catch(error => {});
    },
    setMarker(markers, position) {
      //添加点标记
      this.markers = new AMap.Marker({
        position: position,
        map: this.map_ //把点标记绑在前面初始化的 map_ 上，否则不显示
      });
    },
    setMap(x, y) {
      this.map_.setCenter([x, y]);
      this.map_.setZoom(15);
    }
  }
};
</script>

<style lang="less" scoped>
.middle_content {
  padding-top: 60px;
  min-width: 1200px;
  background: #f4f4f4;
  padding-bottom: 36px;
  &-post {
    width: 100%;
    height: auto;
  }
  &-ditu {
    width: 1200px;
    height: 540px;
    background: #fff;
    margin: 36px auto;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    &-left {
      width: 600px;
      height: 500px;
    }
    &-right {
      width: 540px;
      height: 500px;
      overflow-y: scroll;
      &-item {
        width: 100%;
        height: 154px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 20px 20px;
        box-sizing: border-box;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          background: #f4f4f4;
        }
        &-title {
          font-size: 16px;
        }
        &-flex {
          font-size: 16px;
          color: #666;
          display: flex;
          align-items: center;
          &-icon {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
.inside_img {
  height: 360px;
}
</style>

